import { ErrorListResponse, instanceOfErrorListResponse } from '@genial/services';
import { useEffect, useState } from 'react';

import { useRecoilQuery } from '../../../../../hooks/useRecoilQuery';
import { useToastCreator } from '../../../../../hooks/useToastCreator';
import { equityBySymbolQuery } from '../../../../../store/product/selectors';
import { Offer } from '../../../../NewApplication/Product/components/Equity/constants';
import { OrderEntityWithEvents } from '../../OrderDetails/constants';
import { screenName } from '../constants';

interface ProductProps {
  data?: OrderEntityWithEvents;
}

export const useProduct = ({ data }: ProductProps) => {
  const { showToastFromError } = useToastCreator('product-data-toast');

  const {
    data: productData,
    error: productDataIsError,
    loading: productDataIsLoading,
  } = useRecoilQuery(
    equityBySymbolQuery({
      symbol: data?.offer.symbol!,
      currentScreen: screenName,
    })
  );

  const [amountItem, setAmountItem] = useState(data?.openedQuantity!);
  const [priceItem, setPriceItem] = useState(data?.requestedPrice!);

  const totalPrice = amountItem * priceItem;
  const orderIsValid = totalPrice > 0 && totalPrice <= 1000000;

  const handleChangeAmountItem = (value: number) => setAmountItem(value);
  const handleChangePriceItem = (value: number) => setPriceItem(value);

  useEffect(() => {
    if (productDataIsError) {
      if (instanceOfErrorListResponse(productDataIsError)) {
        (productDataIsError as unknown as ErrorListResponse).errors?.forEach((errorItem) =>
          showToastFromError(errorItem)
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productDataIsError]);

  return {
    productData: productData?.data as unknown as Offer,
    productDataIsLoading,
    productDataIsError,
    amountItem,
    totalPrice,
    priceItem,
    handleChangeAmountItem,
    handleChangePriceItem,
    orderIsValid,
  };
};
